var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNvr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-NVR"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NVR",
    clipPath: "url(#clip-NVR)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    transform: "translate(25 229)",
    fill: "#7b6f6f",
    stroke: "#a79c9c",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 469,
    height: 79,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 465,
    height: 75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    transform: "translate(21 145)",
    fill: "#fcea92",
    stroke: "#fcea92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 473,
    height: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 472,
    height: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    transform: "translate(25 333)",
    fill: "#fcea92",
    stroke: "#fcea92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 469,
    height: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 468,
    height: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    transform: "translate(94 179)",
    fill: "#7b6f6f",
    stroke: "#7b6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    transform: "translate(86 210)",
    fill: "#7b6f6f",
    stroke: "#7b6f6f",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 9,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 80,
    height: 8,
    rx: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_105-2",
    "data-name": "Rectangle 105",
    transform: "translate(94 179)",
    fill: "#7b6f6f",
    stroke: "#7b6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_107-2",
    "data-name": "Rectangle 107",
    transform: "translate(86 210)",
    fill: "#7b6f6f",
    stroke: "#7b6f6f",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 9,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 80,
    height: 8,
    rx: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-2",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-2",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-2",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-2",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193-2",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-3",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-3",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-3",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-3",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194-2",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-4",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-4",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-4",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-4",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193-3",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-5",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-5",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-5",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-5",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194-3",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-6",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-6",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-6",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-6",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1617",
    "data-name": "Path 1617",
    transform: "translate(87 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197-2",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195-2",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193-4",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-7",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-7",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-7",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-7",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1614",
    "data-name": "Path 1614",
    transform: "translate(42 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1615",
    "data-name": "Path 1615",
    transform: "translate(33 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1616",
    "data-name": "Path 1616",
    transform: "translate(24 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194-4",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-8",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-8",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-8",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-8",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196-2",
    "data-name": "Group 196",
    transform: "translate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193-5",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-9",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-9",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-9",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-9",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194-5",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-10",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-10",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-10",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-10",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198-2",
    "data-name": "Group 198",
    transform: "translate(144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193-6",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-11",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-11",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-11",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-11",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194-6",
    "data-name": "Group 194",
    transform: "translate(36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1610-12",
    "data-name": "Path 1610",
    transform: "translate(51 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1611-12",
    "data-name": "Path 1611",
    transform: "translate(60 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1612-12",
    "data-name": "Path 1612",
    transform: "translate(78 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1613-12",
    "data-name": "Path 1613",
    transform: "translate(69 146)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.872206211090088 27.5 L 0.5791707038879395 27.5 L 1.732946634292603 19.67881011962891 L 1.738296627998352 19.64252090454102 L 1.738296627998352 19.6058406829834 L 1.738296627998352 13.69421005249023 L 1.738296627998352 9.027219772338867 L 1.738296627998352 8.99308967590332 L 1.733656644821167 8.959269523620605 L 0.5732645988464355 0.5 L 6.87800931930542 0.5 L 5.735376834869385 8.960300445556641 L 5.730876445770264 8.993610382080078 L 5.730876445770264 9.027219772338867 L 5.730876445770264 13.69421005249023 L 5.730876445770264 19.6058406829834 L 5.730876445770264 19.64196014404297 L 5.736066818237305 19.67770957946777 L 6.872206211090088 27.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.146532535552979 1 L 2.238296508789062 8.958950042724609 L 2.238296508789062 19.67918968200684 L 1.158334732055664 27 L 6.29433536529541 27 L 5.230876922607422 19.67807006835938 L 5.230876922607422 8.959999084472656 L 6.305942535400391 1 L 1.146532535552979 1 M -3.337860107421875e-06 0 L 7.450076580047607 0 L 6.230876445770264 9.027219772338867 L 6.230876445770264 19.60583114624023 L 7.450076580047607 28 L -3.337860107421875e-06 28 L 1.238296508789062 19.60583114624023 L 1.238296508789062 9.027219772338867 L -3.337860107421875e-06 0 Z",
    stroke: "none",
    fill: "#707070"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    transform: "translate(100 183)",
    fill: "#100000",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    transform: "translate(360 183)",
    fill: "#100000",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Sparsh",
    transform: "translate(68.5 238.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 38,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 41
  }, "Sparsh")), /*#__PURE__*/React.createElement("path", {
    id: "moon-svgrepo-com",
    d: "M26.258,50.248A24.191,24.191,0,0,0,50.515,26.124c0-1.116-1.682-1.3-2.263-.345A15.741,15.741,0,1,1,26.6,4.25c.961-.577.775-2.25-.347-2.25a24.124,24.124,0,1,0,0,48.248Z",
    transform: "matrix(0.574, 0.819, -0.819, 0.574, 61.013, 226.215)",
    fill: "#f9f8f8",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    transform: "translate(235 244)",
    fill: "#bcafaf",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 51,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 245,
    height: 50,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-2",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-2",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-2",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-3",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-3",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-3",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-4",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-4",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-4",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-5",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-5",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-5",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-6",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-6",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-6",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111-7",
    "data-name": "Rectangle 111",
    width: 20,
    height: 22,
    transform: "translate(334 253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_112-7",
    "data-name": "Rectangle 112",
    transform: "translate(337 257)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_113-7",
    "data-name": "Rectangle 113",
    transform: "translate(339 260)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 7,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    transform: "translate(468 247)",
    fill: "#cc0a0a",
    stroke: "#cc0a0a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    transform: "translate(468 262)",
    fill: "#f19494",
    stroke: "#f19494",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    transform: "translate(468 277)",
    fill: "#e6d355",
    stroke: "#e6d355",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M4.5,0,9,9H0Z",
    transform: "translate(351 277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M4.5,0,9,9H0Z",
    transform: "translate(386 286) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M4.5,0,9,9H0Z",
    transform: "translate(409.758 276.771) rotate(87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    d: "M4.5,0,9,9H0Z",
    transform: "translate(421.771 285.758) rotate(-87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Network_Video_Processor",
    "data-name": "Network Video Processor",
    transform: "translate(237.5 281.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "Network Video Processor")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvr);
export default __webpack_public_path__ + "static/media/NVR.748cc64a8783a56dd7dad01d39996e5c.svg";
export { ForwardRef as ReactComponent };